import React, { useMemo } from 'react';
import CustomCard from '../../../components/@extended/CustomCard';
import { Box, CardContent, Divider, dividerClasses, Typography } from '@mui/material';
import { Pie } from 'react-chartjs-2';
import { useSelector } from 'react-redux';
import { Grid } from 'amazon-chime-sdk-component-library-react';
import { useParams } from 'react-router-dom';

const FinanceSiteBudgetPie = ({ dashboardData }) => {
  const { trialSiteId } = useParams();

  const { totalBudget, totalExpenditure } = useMemo(() => {
    let totalBudget = 0;
    let totalExpenditure = 0;

    if (!dashboardData?.budgetBreakdown) {
      return { totalBudget, totalExpenditure };
    }

    const { budgetBreakdown } = dashboardData;
    const { sitesBudget } = budgetBreakdown;

    const { siteExpenditure, totalSiteBudget } = sitesBudget.find((site) => site.studySiteId === trialSiteId);

    totalExpenditure = siteExpenditure[0]?.totalAmount ? parseFloat(siteExpenditure[0]?.totalAmount) / 100 : 0;
    totalBudget = totalSiteBudget || 0;
    return {
      totalBudget,
      totalExpenditure,
    };
  }, [dashboardData]);

  const data = useMemo(() => {
    return {
      chartData: {
        labels: ['Total Budget', 'Total Expenditure'],
        datasets: [
          {
            label: 'Cost',
            data: [totalBudget, totalExpenditure],
            backgroundColor: ['#A5D027', '#004078'],
            borderColor: ['#A5D027', '#004078'],
            borderWidth: 1,
          },
        ],
      },
      totalCost: totalExpenditure + totalBudget,
    };
  }, [totalExpenditure, totalBudget]);
  return (
    <CustomCard title="Site Budget" subHeader={'(All costs are in USD)'}>
      <CardContent>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <Pie data={data?.chartData} style={{ height: 350 }} />
        </Box>
        <Grid container>
          <Grid item xs={5.5}></Grid>
          <Grid item xs={0.5}></Grid>
          <Grid item xs={5.5}></Grid>
        </Grid>
        <Box
          sx={{
            display: 'flex',
            columnGap: 2,
            justifyContent: 'center',
            // flexDirection: 'column',
            pt: 2,
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              flexDirection: 'column',
              pt: 2,
            }}
          >
            <Typography variant="subtitle1" color="initial">
              Total Budget
            </Typography>
            <Typography variant="h5" color="initial">
              ${totalBudget}
            </Typography>
          </Box>
          <Box
            sx={{
              height: '100%',
              [`& .${dividerClasses.root}`]: {
                mx: 0.5,
              },
            }}
          >
            <Divider orientation="vertical" flexItem />
          </Box>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              flexDirection: 'column',
              pt: 2,
            }}
          >
            <Typography variant="subtitle1" color="initial">
              Total Expenditure
            </Typography>
            <Typography variant="h5" color="initial">
              ${totalExpenditure}
            </Typography>
          </Box>
        </Box>
      </CardContent>
    </CustomCard>
  );
};

export default FinanceSiteBudgetPie;
